import { render, staticRenderFns } from "./AlertComment.vue?vue&type=template&id=420b3ab6&"
import script from "./AlertComment.vue?vue&type=script&lang=ts&"
export * from "./AlertComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports